import type { FC } from "react";

import { SearchDefaultIcon } from "@jti/brand-icons/search-default";

import { HeaderToolsItem } from "../HeaderToolsItem";

type SearchHeaderButtonProps = {
  isOpened: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export const SearchHeaderButton: FC<SearchHeaderButtonProps> = ({ isOpened, onClose, onOpen }) => {
  const toggle = (isOpened: boolean) => {
    if (isOpened) {
      onClose();
    } else {
      onOpen();
    }
  };
  return (
    <HeaderToolsItem
      data-search-button
      data-testid="search"
      aria-label="searchButton"
      onClick={() => toggle(isOpened)}
      icon={SearchDefaultIcon}
    />
  );
};
